import axios from 'axios'
import dom from './dom'
import viewer from './viewer'
import { AssetsService } from '@coosmo/shared-utils'

function buildList(storyboard, navigatorWidth, navigatorHeight, onPremises) {
  storyboard.collectionDOM.collectionTitle.textContent = storyboard.collectionOptions.collectionTitle

  let html = ''
  storyboard.containers.collectionManifests.forEach(function (manifest, i) {
    html += `
        <li class="story">
            <div class="story-label">${manifest.label}</div>
            <div class="story-description">${manifest.description}</div>
            <a class="story-link" href="#" title="${manifest.label}" data-manifest="${
      manifest['@id']
    }" data-story="${i}">
              <img src="${AssetsService.getSvgIcon('nextStep.svg')}" alt="" id="story-link-button">
            </a>
        </li>
        <div class="separator"></div>
`
  })

  storyboard.collectionDOM.collectionList.innerHTML = html

  storyboard.collectionDOM.storyLinks = document.querySelectorAll('.story-link')
  storyboard.collectionDOM.storyLinks.forEach(function (storyLink) {
    storyLink.addEventListener('click', function (e) {
      e.preventDefault()
      let endpointSegments = e.target.parentNode.dataset.manifest.split('/')
      let idParamIndex = endpointSegments.indexOf('manifest') - 1

      if (storyboard.DOM.stepListContainer === null) {
        dom.init(storyboard, onPremises)
      }
      if (storyboard.viewer !== null) {
        storyboard.viewer.destroy()
      }

      viewer.init(endpointSegments[idParamIndex], storyboard, navigatorWidth, navigatorHeight)

      storyboard.collectionDOM.collectionListContainer.classList.add('hidden')
    })
  })

  storyboard.collectionDOM.collectionListContainer.classList.remove('hidden')
  storyboard.collectionDOM.collectionListContainer.style.opacity = '1'
}

export default {
  initDOM: function (storyboard) {
    storyboard.collectionDOM.collectionListContainer = document.getElementById('collectionListContainer')
    storyboard.collectionDOM.collectionTitle = document.getElementById('collectionTitle')
    storyboard.collectionDOM.collectionList = document.getElementById('collectionList')
  },
  init: function (collectionID, storyboard, navigatorWidth, navigatorHeight, onPremises) {
    const endpoint = `${process.env.API_BASE_URL}meta/iiif/collection/${collectionID}`

    axios.get(endpoint).then(function (response) {
      storyboard.collectionOptions.collectionTitle = response.data.label
      storyboard.containers.collectionManifests = response.data.manifests

      document.getElementById('spinnerContainer').classList.add('hidden')
      buildList(storyboard, navigatorWidth, navigatorHeight, onPremises)
    })
  }
}
